import { useService } from "@policoders/di";
import { BreadcrumbService, TColumn, TTableActions, TTableLineActions } from "@policoders/ds";
import { useEffect, useState } from "react";

import formatHelper from "../../../../core/helpers/formatHelper";
import TechnicalSheetForm from "./form/technical-sheet.form";
import { TechnicalSheet } from "./technical-sheet.model";
import { TechnicalSheetStore } from "./technical-sheet.store";
import responsiveHelper from "../../../../core/helpers/responsiveHelper";

export const useTechnicalSheet = () => {
  const store = useService<TechnicalSheetStore>("TechnicalSheetStore");
  const [lines, setLines] = useState<TechnicalSheet[]>([]);

  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([
      { label: "Chef's Assistant", value: "/chefs-assistant" },
      { label: "Fichas técnias", value: "/chefs-assistant/technical-sheets" },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    store.loadList();
    var subscriber = store.state$.subscribe(state => {
      state.technicalSheets &&
        setLines(
          state.technicalSheets.map(it => ({
            ...it,
            portionCostFormated: formatHelper.currency(it.portionCost),
            salePriceFormated: formatHelper.currency(it.salePrice),
          })),
        );
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [store]);

  const handleSave = async () => {
    store.save();
  };

  const handleNew = () => {
    const model = new TechnicalSheet();
    store.updateCurrent(model);
    store.ui.modal
      .config({
        title: "nova ficha técnica",
        size: responsiveHelper.isSmallScreen() ? "full" : "xlarge",
        buttonOkLabel: "Criar",
        buttonOkAction: handleSave,
        children: () => (
          <TechnicalSheetForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleEdit = (line: TechnicalSheet) => {
    const model = lines.find(x => x.id === line.id);
    if (!model) return;
    store.updateCurrent(model);
    store.ui.modal
      .config({
        title: `editar ficha técnica (${line.id.split("-")[0]})`,
        size: responsiveHelper.isSmallScreen() ? "full" : "xlarge",
        buttonOkLabel: "Salvar",
        buttonOkAction: handleSave,
        children: () => (
          <TechnicalSheetForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleDelete = (line: TechnicalSheet) => {
    if (window.confirm("excluir ficha técnica?")) store.delete(line.id);
  };

  const tActions: TTableLineActions[] = [{ label: "excluir", onClick: handleDelete }];

  const tColumns: TColumn[] = [
    { field: "recipeCode", title: "Código", columnClass: "d-none d-md-table-cell" },
    { field: "recipeName", title: "Produto" },
    { field: "portions", title: "Porções", columnClass: "d-sm-table-cell" },
    {
      field: "portionCostFormated",
      title: "Custo",
      columnClass: "d-lg-table-cell text-nowrap",
    },
    {
      field: "salePriceFormated",
      title: "Venda",
      columnClass: "d-md-table-cell text-nowrap",
    },
  ];

  const tHeaderButtons: TTableActions = {
    buttonNew: {
      label: "Novo",
      action: handleNew,
    },
  };

  return {
    lines,
    tActions,
    tColumns,
    tHeaderButtons,
    handleEdit,
  };
};
